module.exports = __webpack_public_path__ + "img/image1.de61fb82.jpg";